/** User access mode for PACS equipment */
export enum AccessModeEnum {
  /** The user has access to all rooms (if the corresponding flag is enabled) */
  EVERYWHERE = 'EVERYWHERE',
  /** The user has access to specific rooms */
  BY_ROOMS = 'BY_ROOMS',
}
